export const GET_MODIFIER_GROUPS = 'providers/menuMaker/MenuMakerModifierGroups/GET_MODIFIER_GROUPS';
export const GET_PAGINATION_MODIFIER_GROUP =
  'providers/menuMaker/MenuMakerModifierGroups/GET_PAGINATION_MODIFIER_GROUP';
export const CREATE_MODIFIER_GROUP = 'providers/menuMaker/MenuMakerModifierGroups/CREATE_MODIFIER_GROUP';
export const DELETE_MODIFIER_GROUP = 'providers/menuMaker/MenuMakerModifierGroups/DELETE_MODIFIER_GROUP';
export const DUPLICATE_MODIFIER_GROUP = 'providers/menuMaker/MenuMakerModifierGroups/DUPLICATE_MODIFIER_GROUP';
